export default "__VITE_ASSET__CVJl0Urf__"